"use strict";

module.exports = /* @ngInject */ function(componentRepository) {
  var that = this;

  componentRepository.getAll().then(function(components) {
    that.components = components;
  });
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/HomeController.js